import { Permiso } from './../../entities/Enums/permiso.enum';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    permiso: Permiso.ConsultarTablero,
    isTitle: true,
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    permiso: Permiso.ConsultarTablero,
    icon: 'uil-home-alt',
    badge: {
      variant: 'primary',
      text: '01',
    },
    link: '/default',
  },
  {
    id: 3,
    label: 'MENUITEMS.ADMIN.TEXT',
    permiso: Permiso.ConsultarAdministracion,
    icon: 'uil-apps',
    subItems: [
      {
        id: 4,
        label: 'MENUITEMS.ADMIN.LIST.MODULES',
        permiso: Permiso.ConsultarModulos,
        link: '/administracion/modulos',
        parentId: 3,
      },
      {
        id: 5,
        label: 'MENUITEMS.ADMIN.LIST.PERMISSION',
        permiso: Permiso.ConsultarPermisos,
        link: '/administracion/permisos',
        parentId: 3,
      },
      {
        id: 20,
        label: 'MENUITEMS.ADMIN.LIST.METODOS',
        permiso: Permiso.ConsultarMetodoPago,
        link: '/administracion/metodos-pago',
        parentId: 3,
      },
      {
        id: 20,
        label: 'Ladas Teléfonicas',
        permiso: Permiso.ConsultarLadas,
        link: '/administracion/ladas-telefonicas',
        parentId: 3,
      },
      {
        id: 109,
        label: 'Comisionistas',
        link: '/administracion/comisionistas',
        parentId: 3,
      },
      {
        id: 106,
        label: 'Proveedores',
        permiso: Permiso.ConsultarProveedores,
        parentId: 104,
        subItems: [
            {
                id: 107,
                label: 'Lista Proveedores',
                permiso: Permiso.ConsultarProveedores,
                link: '/administracion/proveedores',
                parentId: 104,
            },
            {
                id: 108,
                label: 'Switcher',
                permiso: Permiso.SwitcherProveedores,
                link: '/administracion/switcher-proveedor',
                parentId: 104,
            }
        ]
    },
      {
        id: 9,
        label: 'MENUITEMS.ADMIN.LIST.LOGBOOK',
        permiso: Permiso.ConsultarBitacora,
        link: '/administracion/bitacora',
        parentId: 3,
      },
    ],
  },
  {
    id: 62,
    label: 'Compras Proveedores',
    permiso: Permiso.ConsultarCompraProveedores,
    icon: 'uil-bill',
    subItems: [
      {
        id: 63,
        label: 'Realizar Compra',
        permiso: Permiso.AgregarCompraProveedores,
        link: '/compras/alta-compra',
        parentId: 62,
      },
      {
        id: 63,
        label: 'Lista de Compras',
        permiso: Permiso.ConsultarCompraProveedores,
        link: '/compras/lista-compras',
        parentId: 62,
      },
    ],
  },
  {
    id: 44,
    label: 'MENUITEMS.CLIENTES.TEXT',
    permiso: Permiso.ConsultarCliente,
    icon: 'uil-user-check',
    subItems: [
      {
        id: 18,
        label: 'MENUITEMS.CLIENTES.LIST.ADDUSER',
        permiso: Permiso.AgregarCliente,
        link: '/clientes/alta-cliente',
        parentId: 44,
      },
      {
        id: 19,
        label: 'MENUITEMS.CLIENTES.LIST.USERLIST',
        permiso: Permiso.ConsultarCliente,
        link: '/clientes/lista-clientes',
        parentId: 44,
      },
    ],
  },
  {
    id: 4,
    label: 'MENUITEMS.ENTITIES.TEXT',
    permiso: Permiso.ConsultarEntidades,
    icon: 'uil-store',
    subItems: [
      {
        id: 6,
        label: 'MENUITEMS.ENTITIES.LIST.STORE',
        permiso: Permiso.ConsultarCadena,
        link: '/administracion/cadena',
        parentId: 4,
      },
      {
        id: 7,
        label: 'MENUITEMS.ENTITIES.LIST.BRANCH',
        permiso: Permiso.ConsultarSucursal,
        link: '/administracion/sucursal',
        parentId: 4,
      },
      {
        id: 8,
        label: 'MENUITEMS.ENTITIES.LIST.CASHREGISTER',
        permiso: Permiso.ConsultarCaja,
        link: '/administracion/caja',
        parentId: 4,
      }
    ]
  },
  {
    id: 5,
    label: 'MENUITEMS.USERS.TEXT',
    permiso: Permiso.ConsultarUsuario,
    icon: 'uil-users-alt',
    subItems: [
      {
        id: 15,
        label: 'MENUITEMS.USERS.LIST.ADDUSER',
        permiso: Permiso.AgregarUsuario,
        link: '/usuarios/alta-usuario',
        parentId: 5,
      },
      {
        id: 16,
        label: 'MENUITEMS.USERS.LIST.USERLIST',
        permiso: Permiso.ConsultarUsuario,
        link: '/usuarios/lista-usuarios',
        parentId: 5,
      },
      {
        id: 115,
        label: 'Restaurar Contraseña',
        permiso: Permiso.RestaurarContrasenaUsuarios,
        link: '/usuarios/restaurar-contrasena',
        parentId: 5,
      },
    ],
  },
  {
    id: 52,
    label: 'Roles',
    permiso: Permiso.ConsultarRoles,
    icon: 'uil-gold',
    subItems: [
      {
        id: 15,
        label: 'Agregar Rol',
        permiso: Permiso.AgregarRol,
        link: '/roles/agregar-rol',
        parentId: 52,
      },
      {
        id: 16,
        label: 'Lista de Roles',
        permiso: Permiso.ConsultarRoles,
        link: '/roles/lista-roles',
        parentId: 52,
      },
    ],
  },
  // {
  //   id: 6,
  //   label: 'MENUITEMS.APPS.TEXT',
  //   permiso: Permiso.ConsultaDePago,
  //   isTitle: true,
  // },
  // {
  //   id: 7,
  //   label: 'MENUITEMS.PAYMENTCENTER.TEXT',
  //   permiso: Permiso.ConsultaDePago,
  //   icon: 'uil-phone-alt',
  //   link: '/cell-payment-service',
  // },

  {
    id: 6,
    label: 'Recarga Electrónica',
    permiso: Permiso.ConsultaDePago,
    isTitle: true,
  },
  {
    id: 7,
    label: 'Punto de Venta',
    permiso: Permiso.ConsultaDePago,
    icon: 'uil-phone-alt',
    link: '/recargas',
  },
  {
    id: 60,
    label: 'POS Masivo',
    permiso: Permiso.POSMasivo,
    icon: 'uil-file-upload',
    link: '/pos-masivo',
  },
  {
    id: 50,
    label: 'Reporte de Ventas',
    permiso: Permiso.ReporteVentas,
    icon: 'uil-file-alt',
    link: '/reporte-ventas',
  },
  {
    id: 110,
    label: 'Reporte Ventas Con Comisión',
    permiso: Permiso.ReporteVentas,
    icon: 'uil-file-alt',
    link: '/reporte-ventas-comision',
  },
  {
    id: 116,
    label: 'Reporte por Comisionista',
    permiso: Permiso.ReporteVentas,
    icon: 'uil-file-alt',
    link: '/reporte-comisionista',
  },
  {
    id: 8,
    permiso: Permiso.ConsultarTransacciones,
    label: 'MENUITEMS.REPORTS.TEXT',
    isTitle: true,
  },
  {
    id: 9,
    label: 'Analytics',
    permiso: Permiso.ConsultarTransacciones,
    icon: 'uil-file-search-alt',
    link: '/analytics',
  },
  {
    id: 51,
    label: 'Reportes',
    icon: 'uil-money-withdraw',
    permiso: Permiso.ConsultarCorteDelDia,
    subItems: [
      {
        id: 64,
        label: 'Corte del Día',
        permiso: Permiso.ConsultarCorteDelDia,
        icon: 'uil-moonset',
        link: '/corte-del-dia',
      },
      {
        id: 48,
        label: 'Conciliaciones',
        icon: 'uil-file-check-alt',
        permiso: Permiso.ConsultarConciliaciones,
        link: '/conciliaciones',
        parentId: 64,
      },
      {
        id: 48,
        label: 'Conciliaciones Prov',
        permiso:Permiso.ConsultarConciliacionesProv,
        icon: 'uil-money-bill',
        link: '/conciliaciones-provedor',
        parentId: 64,
      },
      {
        id: 90,
        label: 'Reporte Gasto por Horas',
        permiso:Permiso.ConsultarReporteGastos,
        icon: 'uil-money-bill',
        link: '/reporte-gasto-horas',
        parentId: 64,
      },
      {
        id: 48,
        label: 'Estado de Cuenta',
        permiso: Permiso.ConsultarEstadosCuenta,
        icon: 'uil-money-bill',
        link: '/estado-cuenta',
        parentId: 64,
      },
    ],
  },
  /*{
    id: 48,
    label: 'Estado de Cuenta',
    icon: 'uil-file-copy-alt',
    permiso: Permiso.ConsultarEstadosCuenta,
    link: '/estado-cuenta',
    parentId: 64,
  },*/
  {
    id: 6,
    label: 'Provedores',
    permiso: Permiso.ConsultaProvedores,
    isTitle: true,
  },
  {
    id: 7,
    label: 'Switcher',
    permiso: Permiso.ConsultaProvedores,
    icon: 'uil-process',
    link: '/switcher',
  },
  {
    id: 47,
    label: 'MENUITEMS.BALANCES.TEXT',
    permiso: Permiso.AsignarSaldos,
    isTitle: true,
  },
  {
    id: 48,
    label: 'Saldos',
    permiso: Permiso.Saldos,
    icon: 'uil-money-bill',
    link: '/saldos',
    parentId: 48,
  },
 /* {
    id: 48,
    label: 'Conciliaciones',
    icon: 'uil-money-bill',
    link: '/conciliaciones',
    parentId: 64,
  },*/
  {
    id: 51,
    label: 'Depósitos Bancarios',
    permiso: Permiso.ConsultarDepositos,
    icon: 'uil-money-withdraw',
    subItems: [
      {
        id: 15,
        label: 'Agregar Depósito',
        permiso: Permiso.AgregarDeposito,
        link: '/depositos/agregar-deposito',
        parentId: 51,
      },
      {
        id: 16,
        link: '/depositos/lista-depositos',
        permiso: Permiso.ConsultarDepositos,
        label: 'Lista de Depósitos',
        parentId: 51,
      },
    ],
  },
  {
    id: 48,
    label: 'Venta de Saldo',
    permiso: Permiso.AsignarSaldos,
    icon: 'uil-dollar-sign-alt',
    link: '/saldo/alta-saldo',
    parentId: 47,
  },
  {
    id: 49,
    label: 'MENUITEMS.BALANCES.LIST.TRANSFER',
    permiso: Permiso.ConsultarTraspasos,
    icon: 'uil-arrows-h',
    link: '/saldo/traspaso-saldo',
    parentId: 47,
  },
  {
    id: 50,
    label: 'MENUITEMS.BALANCES.LIST.REVERSE',
    permiso: Permiso.ConsultarTraspasos,
    icon: 'uil-arrows-h',
    link: '/saldo/reversa-saldo',
    parentId: 47,
  },
  {
    id: 45,
    label: 'MENUITEMS.INTEGRATION.TEXT',
    permiso: Permiso.ConsultarDocumentacion,
    isTitle: true,
  },
  {
    id: 46,
    label: 'MENUITEMS.INTEGRACIONES.TEXT',
    permiso: Permiso.ConsultarDocumentacion,
    icon: 'uil-visual-studio',
    subItems: [
      {
        id: 105,
        label: 'Bienvenido',
        link: '/desarrolladores/bienvenida',
        permiso: Permiso.ConsultarBienvenidaD,
        parentId: 46
      },
      {
        id: 125,
        label: 'Autenticación',
        permiso: Permiso.ConsultarAutenticacion,
        parentId: 46,
        subItems: [
          {
            id: 107,
            label: 'Login',
            link: '/desarrolladores/login',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 125,
          },
          // {
          //   id: 107,
          //   label: 'Restaurar Contraseña',
          //   link: '/desarrolladores/envio-correo',
          //   badge: {
          //     variant: 'warning',
          //     text: 'POST'
          //   },
          //   parentId: 125,
          // },
          {
            id: 108,
            label: 'Cambio Contraseña',
            link: '/desarrolladores/cambio-contrasena',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 125,
          },
        ]
      },
      {
        id: 130,
        label: 'Módulos',
        permiso: Permiso.ConsultarModulosD,
        parentId: 130,
        subItems: [
          {
            id: 107,
            label: 'Obtener Módulos',
            link: '/desarrolladores/get-modulos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 125,
          },
          {
            id: 107,
            label: 'Agregar Módulo',
            link: '/desarrolladores/post-modulo',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 125,
          },
          {
            id: 109,
            label: 'Actualizar Módulo',
            link: '/desarrolladores/put-modulo',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 108,
          },
          {
            id: 108,
            label: 'Obtener Módulo Id',
            link: '/desarrolladores/getbyid-modulo',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 108,
          },
          {
            id: 110,
            link: '/desarrolladores/update-modulo',
            badge: {
              variant: 'primary',
              text: 'PATCH'
            },
            label: 'Actualizar Módulo',
            parentId: 108,
          },
        ]
      },
      {
        id: 131,
        label: 'Permisos',
        permiso: Permiso.ConsultarPermisosD,
        parentId: 131,
        subItems: [
          {
            id: 131,
            label: 'Obtener Permisos',
            link: '/desarrolladores/get-permisos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 131,
          },
          {
            id: 131,
            label: 'Agregar Permiso',
            link: '/desarrolladores/post-permisos',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 125,
          },
          {
            id: 109,
            label: 'Actualizar Permiso',
            link: '/desarrolladores/put-permiso',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 108,
          },
          {
            id: 109,
            label: 'Obtener Permiso Id',
            link: '/desarrolladores/getbyid-permiso',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 108,
          },
          {
            id: 109,
            link: '/desarrolladores/update-permiso',
            badge: {
              variant: 'primary',
              text: 'PATCH'
            },
            label: 'Actualizar Permiso',
            parentId: 108,
          },
        ]
      },
      {
        id: 132,
        label: 'Ladas Telefónicas',
        permiso: Permiso.ConsultarLadasTelefonicasD,
        parentId: 132,
        subItems: [
          {
            id: 107,
            label: 'Obtener Ladas',
            link: '/desarrolladores/get-ladas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 125,
          },
        ]
      },
      {
        id: 134,
        label: 'Proveedores',
        permiso: Permiso.ConsultarProveedoresD,
        parentId: 134,
        subItems: [
          {
            id: 100,
            label: 'Obtener Proveedores',
            link: '/desarrolladores/get-proveedores',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 134,
          },
          {
            id: 100,
            label: 'Agregar Proveedor',
            link: '/desarrolladores/post-proveedor',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 134,
          },
          {
            id: 100,
            label: 'Actualizar Proveedor',
            link: '/desarrolladores/put-proveedor',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 134,
          },
          {
            id: 100,
            label: 'Obtener Proveedor Id',
            link: '/desarrolladores/getbyid-proveedor',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 134,
          },
          {
            id: 100,
            link: '/desarrolladores/delete-proveedor',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            label: 'Eliminar Proveedor',
            parentId: 134,
          },
        ]
      },
      {
        id: 135,
        label: 'Switcher Proveedor',
        permiso: Permiso.ConsultarSwitcherProveedorD,
        parentId: 135,
        subItems: [
          {
            id: 100,
            label: 'Obtener Switcher Prov',
            link: '/desarrolladores/get-switcher-proveedor',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 135,
          },
          {
            id: 101,
            label: 'Asignar Switcher Prov',
            link: '/desarrolladores/put-asignar-switcherProveedor',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 134,
          },
          {
            id: 102,
            label: 'Desasg Switcher Prov',
            link: '/desarrolladores/put-desasignar-switcherProveedor',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 134,
          },
          {
            id: 103,
            label: 'Agregar Produc Proveedor',
            link: '/desarrolladores/post-productoProveedor',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 134,
          },
        ]
      },
      {
        id: 106,
        label: 'MENUITEMS.INTEGRACIONES.LIST.LEVEL1.2',
        permiso: Permiso.ConsultarTransaccionesD,
        parentId: 46,
        subItems: [
          {
            id: 128,
            label: 'Balance',
            link: '/desarrolladores/get-balance',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 106,
          },
          {
            id: 128,
            label: 'Sale Check',
            link: '/desarrolladores/get-salecheck',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 106,
          },
          {
            id: 107,
            label: 'Sale Request',
            link: '/desarrolladores/post-salerequest',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 106,
          },
          {
            id: 107,
            label: 'Transacciones',
            link: '/desarrolladores/transacciones',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 106,
          },
          {
            id: 127,
            label: 'SKU',
            link: '/desarrolladores/get-sku',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 106,
          },
        ]
      },
      {
        id: 108,
        label: 'Clientes',
        permiso: Permiso.ConsultarClientesD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Clientes',
            link: '/desarrolladores/get-clientes',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 108,
          },
          {
            id: 107,
            label: 'Agregar Cliente',
            link: '/desarrolladores/post-clientes',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 108,
          },
          {
            id: 109,
            label: 'Actualizar Cliente',
            link: '/desarrolladores/put-clientes',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 108,
          },
          {
            id: 108,
            label: 'Obtener Cliente Id',
            link: '/desarrolladores/getbyid-clientes',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 108,
          },
          {
            id: 110,
            link: '/desarrolladores/delete-clientes',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            label: 'Eliminar Cliente',
            parentId: 108,
          },
          {
            id: 107,
            label: 'Agregar Imagen',
            link: '/desarrolladores/postimage-clientes',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 108,
          },
        ]
      },
      {
        id: 107,
        label: 'Cadenas',
        permiso: Permiso.ConsultarCadenasD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Cadenas',
            link: '/desarrolladores/get-cadenas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 107,
          },
          {
            id: 107,
            label: 'Agregar Cadena',
            link: '/desarrolladores/post-cadenas',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 107,
          },
          {
            id: 109,
            label: 'Actualizar Cadena',
            link: '/desarrolladores/put-cadenas',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 107,
          },
          {
            id: 111,
            link: '/desarrolladores/getbyid-cadena',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Cadena ID',
            parentId: 107,
          },
          {
            id: 110,
            link: '/desarrolladores/delete-cadenas',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            label: 'Eliminar Cadena',
            parentId: 107,
          },
          {
            id: 112,
            link: '/desarrolladores/postimage-cadena',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            label: 'Subir Imagen',
            parentId: 107,
          }
        ]
      },
      {
        id: 113,
        label: 'Sucursales',
        permiso: Permiso.ConsultarSucursalesD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Sucursales',
            link: '/desarrolladores/get-sucursales',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 107,
          },
          {
            id: 107,
            label: 'Agregar Sucursal',
            link: '/desarrolladores/post-sucursal',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 107,
          },
          {
            id: 109,
            label: 'Actualizar Sucursal',
            link: '/desarrolladores/put-sucursal',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 107,
          },
          {
            id: 111,
            label: 'Obtener Sucursal ID',
            link: '/desarrolladores/getbyid-sucursal',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 107,
          },
          {
            id: 110,
            label: 'Eliminar Sucursal',
            link: '/desarrolladores/delete-sucursal',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            parentId: 107,
          },
          {
            id: 112,
            label: 'Obtener Sucursal by idCadena',
            link: '/desarrolladores/getbyid-cadena-sucursal',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 107,
          }
        ]
      },
      {
        id: 114,
        label: 'Cajas',
        parentId: 46,
        permiso: Permiso.ConsultarCajasD,
        subItems: [
          {
            id: 108,
            label: 'Obtener Cajas',
            link: '/desarrolladores/get-cajas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 114,
          },
          {
            id: 107,
            label: 'Agregar Caja',
            link: '/desarrolladores/post-caja',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 114,
          },
          {
            id: 109,
            label: 'Actualizar Caja',
            link: '/desarrolladores/put-caja',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 114,
          },
          {
            id: 111,
            link: '/desarrolladores/getbyid-caja',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Caja ID',
            parentId: 114,
          },
          {
            id: 110,
            link: '/desarrolladores/delete-caja',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            label: 'Eliminar Caja',
            parentId: 114,
          },
        ]
      },
      {
        id: 108,
        label: 'Usuarios',
        permiso: Permiso.ConsultarUsuariosD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Usuarios',
            link: '/desarrolladores/get-usuarios',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 108,
          },
          {
            id: 111,
            link: '/desarrolladores/getbyid-usuario',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Usuario ID',
            parentId: 108,
          },
          {
            id: 110,
            link: '/desarrolladores/delete-usuario',
            badge: {
              variant: 'danger',
              text: 'DELETE'
            },
            label: 'Eliminar Usuario',
            parentId: 108,
          },
          {
            id: 107,
            label: 'Agregar Usuario',
            link: '/desarrolladores/post-usuario',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 108,
          },
          {
            id: 109,
            label: 'Actualizar Usuario',
            link: '/desarrolladores/put-usuario',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 108,
          },
          {
            id: 112,
            link: '/desarrolladores/postimage-usuario',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            label: 'Subir Imagen',
            parentId: 108,
          }
        ]
      },
      {
        id: 115,
        label: 'Roles',
        permiso: Permiso.ConsultarRolesD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Roles',
            link: '/desarrolladores/get-roles',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 115,
          },
          {
            id: 107,
            label: 'Agregar Rol',
            link: '/desarrolladores/post-rol',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 115,
          },
          {
            id: 109,
            label: 'Actualizar Rol',
            link: '/desarrolladores/put-rol',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 115,
          },
          {
            id: 111,
            link: '/desarrolladores/getbyid-rol',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Rol ID',
            parentId: 115,
          },
          {
            id: 150,
            link: '/desarrolladores/permisosAgrupados-rol',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Permisos',
            parentId: 115,
          },
        ]
      },
      {
        id: 116,
        label: 'Punto de Venta',
        permiso: Permiso.ConsultarPuntoVentaD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Marcas',
            link: '/desarrolladores/punto-venta-marcas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 116,
          },
          {
            id: 108,
            label: 'Obtener Favoritos',
            link: '/desarrolladores/lista-favoritos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 116,
          },
          {
            id: 107,
            label: 'Agregar Favorito',
            link: '/desarrolladores/post-favorito',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 114,
          },
          {
            id: 107,
            label: 'Desactivar Favorito',
            link: '/desarrolladores/desactivar-favorito',
            badge: {
              variant: 'primary',
              text: 'POST'
            },
            parentId: 114,
          },
          {
            id: 111,
            link: '/desarrolladores/get-categoriasByMarca',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Categorias por Marca',
            parentId: 114,
          },
          {
            id: 111,
            link: '/desarrolladores/get-skuByCategoria',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Sku por Categoría',
            parentId: 114,
          },
          {
            id: 111,
            link: '/desarrolladores/get-categoriasByMarca-POS',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'POS - Obtener Categoría Por Marca',
            parentId: 114,
          },
          {
            id: 111,
            link: '/desarrolladores/get-skuByCategoria-POS',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'POS - Obtener Sku por Categoría',
            parentId: 114,
          },
          {
            id: 107,
            label: 'Agregar Transacción',
            link: '/desarrolladores/post-transaccion',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 114,
          },
        ]
      },
      {
        id: 117,
        label: 'Reporte de Ventas',
        permiso: Permiso.ConsultarReporteVentasD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Reporte',
            link: '/desarrolladores/get-reporte-ventas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 117,
          },
        ]
      },
      {
        id: 118,
        label: 'Analytics',
        permiso: Permiso.ConsultarAnalyticsD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Analytics',
            link: '/desarrolladores/get-analytics',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 108,
            label: 'Obtener Saldo Clientes',
            link: '/desarrolladores/get-saldos-clientes',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 108,
            label: 'Obtener Saldos Proveedor',
            link: '/desarrolladores/get-saldos-proveedores',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
        ]
      },
      {
        id: 119,
        label: 'Switcher',
        permiso: Permiso.ConsultarSwitcherD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Reporte',
            link: '/desarrolladores/get-switcher',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 119,
          },
          {
            id: 108,
            label: 'Obtener Clientes',
            link: '/desarrolladores/get-clientes-switcher',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 119,
          },
          {
            id: 108,
            label: 'Obtener Cadena por Cliente',
            link: '/desarrolladores/get-cadenas-byCliente',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 119,
          },
        ]
      },
      {
        id: 120,
        label: 'Saldos',
        permiso: Permiso.ConsultarSaldosD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Saldo',
            link: '/desarrolladores/get-saldos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 120,
          },
        ]
      },
      {
        id: 121,
        label: 'Depósitos',
        permiso: Permiso.ConsultarDepositosD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Depósitos',
            link: '/desarrolladores/get-depositos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
          {
            id: 107,
            label: 'Agregar Depósito',
            link: '/desarrolladores/post-deposito',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 121,
          },
          {
            id: 109,
            label: 'Subir Imagen',
            link: '/desarrolladores/postimage-deposito',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
        ]
      },
      {
        id: 121,
        label: 'Venta Saldo',
        permiso: Permiso.ConsultarVentaSaldoD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Historico',
            link: '/desarrolladores/get-historico',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
          // {
          //   id: 109,
          //   label: 'Obtener Cadenas',
          //   link: '/desarrolladores/get-cadenas',
          //   badge: {
          //     variant: 'success',
          //     text: 'GET'
          //   },
          //   parentId: 121,
          // },
          {
            id: 110,
            label: 'Obtener Clientes',
            link: '/desarrolladores/get-clientes',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
          {
            id: 111,
            label: 'Obtener M. por Cliente',
            link: '/desarrolladores/get-marca-byIdCliente',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
          {
            id: 112,
            label: 'Obtener Regiones',
            link: '/desarrolladores/get-regiones',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 121,
          },
          {
            id: 113,
            label: 'Asignar Saldo',
            link: '/desarrolladores/post-asignar-saldo',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 121,
          },
        ]
      },
      {
        id: 118,
        label: 'Traspasar Saldo',
        permiso: Permiso.ConsultarTraspasarSaldoD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Obtener Traspasos',
            link: '/desarrolladores/get-traspasos',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 109,
            label: 'Obtener Niveles',
            link: '/desarrolladores/get-niveles',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 108,
            label: 'Obtener Cadenas',
            link: '/desarrolladores/get-cadenas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 108,
            label: 'Obtener Sucursales',
            link: '/desarrolladores/get-sucursales',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 108,
            label: 'Obtener Cajas',
            link: '/desarrolladores/get-cajas',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            parentId: 118,
          },
          {
            id: 111,
            link: '/desarrolladores/getbyid-caja',
            badge: {
              variant: 'success',
              text: 'GET'
            },
            label: 'Obtener Caja ID',
            parentId: 118,
          },
          {
            id: 112,
            label: 'Traspasar Saldo',
            link: '/desarrolladores/post-traspaso',
            badge: {
              variant: 'warning',
              text: 'POST'
            },
            parentId: 118,
          },
        ]
      },
      {
        id: 120,
        label: 'Perfil de Usuario',
        permiso: Permiso.ConsultarPerfilUsuarioD,
        parentId: 46,
        subItems: [
          {
            id: 108,
            label: 'Actualizar Usuario',
            link: '/desarrolladores/put-informacion-perfil',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 120,
          },
          {
            id: 108,
            label: 'Actualizar Contraseña',
            link: '/desarrolladores/put-contrasena-perfil',
            badge: {
              variant: 'info',
              text: 'PUT'
            },
            parentId: 120,
          },
        ]
      },
    ]
  },
  {
    id: 60,
    label: 'Ajustes',
    isTitle: true,
  },
  {
    id: 61,
    label: 'Perfil de Usuario',
    icon: 'uil-chat-bubble-user',
    link: '/contacts/profile',
  },
  {
    id: 42,
    label: 'MENUITEMS.CIERRE.TEXT',
    isTitle: true,
  },
  {
    id: 43,
    label: 'MENUITEMS.CIERRESESION.TEXT',
    icon: 'uil-arrow-circle-right',
    link: '/account/login',
  },
];
